var map = {
	"./Anyswap.png": 494,
	"./Anyswap.svg": 495,
	"./Artwork.svg": 496,
	"./Artwork_gmx.svg": 497,
	"./Banxa.png": 498,
	"./DROP_DOWN.svg": 285,
	"./Frame.svg": 499,
	"./Hop.png": 500,
	"./Hop.svg": 501,
	"./Hop_dark.png": 502,
	"./Hop_dark.svg": 503,
	"./Synapse.png": 504,
	"./Synapse.svg": 505,
	"./binance.png": 506,
	"./bscscan.png": 507,
	"./btn_big_arbitrum.png": 508,
	"./btn_big_avalanche.png": 509,
	"./btn_big_bsc.png": 510,
	"./btn_big_purchasegmx.png": 511,
	"./btn_big_purchasegmx.svg": 512,
	"./buy_gmx.svg": 286,
	"./buy_gmx_bond.svg": 513,
	"./buy_transfer_eth.svg": 514,
	"./coinbaseWallet.png": 287,
	"./coingecko.png": 515,
	"./cross.svg": 516,
	"./flag_en.svg": 517,
	"./flag_es.svg": 518,
	"./flag_fr.svg": 519,
	"./flag_ja.svg": 520,
	"./flag_ko.svg": 521,
	"./flag_ru.svg": 522,
	"./flag_zh.svg": 523,
	"./glp_icon.svg": 524,
	"./gmx-logo-final-white-small.png": 525,
	"./gmx-logo-final-white.png": 526,
	"./gmx-logo-final.png": 527,
	"./gmx-logo-glow.png": 528,
	"./gmx-logo-with-name.svg": 288,
	"./gmx_logo.svg": 529,
	"./graphite-01.png": 530,
	"./ic-communityproject.svg": 531,
	"./ic_aave_24.svg": 532,
	"./ic_aave_30.svg": 533,
	"./ic_aave_40.svg": 534,
	"./ic_arbitrum_16.svg": 131,
	"./ic_arbitrum_24.svg": 167,
	"./ic_arbitrum_96.svg": 193,
	"./ic_arbitrum_hover_16.svg": 535,
	"./ic_arrowleft16.svg": 536,
	"./ic_arrowright16.svg": 537,
	"./ic_avalanche_16.svg": 115,
	"./ic_avalanche_24.svg": 168,
	"./ic_avalanche_96.svg": 194,
	"./ic_avax_24.svg": 538,
	"./ic_avax_30.svg": 539,
	"./ic_avax_40.svg": 540,
	"./ic_banxa.svg": 289,
	"./ic_binance.svg": 541,
	"./ic_binance_logo.svg": 542,
	"./ic_bsc.svg": 543,
	"./ic_bsc_96.svg": 544,
	"./ic_btc.b_24.svg": 545,
	"./ic_btc.b_40.svg": 546,
	"./ic_btc_24.svg": 547,
	"./ic_btc_40.svg": 548,
	"./ic_bungee.png": 290,
	"./ic_busd_24.svg": 549,
	"./ic_buy_glp.svg": 291,
	"./ic_cash.png": 550,
	"./ic_cash.svg": 551,
	"./ic_checked.svg": 292,
	"./ic_coingecko_16.svg": 293,
	"./ic_coingecko_hover_16.svg": 552,
	"./ic_convert_down.svg": 294,
	"./ic_copy_16.svg": 295,
	"./ic_cost.svg": 296,
	"./ic_dai_24.svg": 553,
	"./ic_dai_40.svg": 554,
	"./ic_discord.svg": 297,
	"./ic_eth_24.svg": 555,
	"./ic_eth_40.svg": 556,
	"./ic_frax_24.svg": 557,
	"./ic_frax_40.svg": 558,
	"./ic_github.svg": 559,
	"./ic_glp_24.svg": 239,
	"./ic_glp_40.svg": 195,
	"./ic_glp_40_.svg": 560,
	"./ic_glp_custom.svg": 298,
	"./ic_glp_custom_.svg": 561,
	"./ic_gmx.svg": 562,
	"./ic_gmx_24.svg": 563,
	"./ic_gmx_30.svg": 564,
	"./ic_gmx_40.svg": 299,
	"./ic_gmx_40_.svg": 565,
	"./ic_gmx_64.svg": 566,
	"./ic_gmx_arbitrum.svg": 567,
	"./ic_gmx_avax.svg": 568,
	"./ic_gmx_big.svg": 569,
	"./ic_gmx_custom.svg": 300,
	"./ic_gmx_custom_ (2).svg": 570,
	"./ic_gmx_custom_.svg": 571,
	"./ic_gmx_footer.svg": 301,
	"./ic_gmx_footer_.svg": 572,
	"./ic_hop.svg": 573,
	"./ic_info.svg": 574,
	"./ic_language24.svg": 353,
	"./ic_link.e_40.svg": 575,
	"./ic_link_24.svg": 576,
	"./ic_link_40.svg": 577,
	"./ic_liquidity.svg": 302,
	"./ic_medium.svg": 578,
	"./ic_menu_dots.svg": 579,
	"./ic_metamask_16.svg": 303,
	"./ic_metamask_hover_16.svg": 580,
	"./ic_mim_24.svg": 581,
	"./ic_mim_40.svg": 582,
	"./ic_multiswap.svg": 583,
	"./ic_new_link_16.svg": 304,
	"./ic_o3.png": 305,
	"./ic_olympus.svg": 584,
	"./ic_olympus_arbitrum.svg": 306,
	"./ic_selector_dropdowns.svg": 585,
	"./ic_settings_16.svg": 240,
	"./ic_settings_24.svg": 586,
	"./ic_sign in_16.svg": 587,
	"./ic_sign_out_16.svg": 307,
	"./ic_simpleswaps.svg": 308,
	"./ic_stats.svg": 309,
	"./ic_stats_big.svg": 588,
	"./ic_synapse.svg": 589,
	"./ic_telegram.svg": 590,
	"./ic_tether_24.svg": 591,
	"./ic_tokens.svg": 592,
	"./ic_totaluser.svg": 310,
	"./ic_traderjoe.png": 311,
	"./ic_trading.svg": 312,
	"./ic_transfer_avax.svg": 593,
	"./ic_twitter.svg": 313,
	"./ic_uni_24.svg": 594,
	"./ic_uni_40.svg": 595,
	"./ic_uni_arbitrum.svg": 314,
	"./ic_usdc.e_24.svg": 596,
	"./ic_usdc.e_40.svg": 597,
	"./ic_usdc_24.svg": 598,
	"./ic_usdc_40.svg": 599,
	"./ic_usdt_24.svg": 600,
	"./ic_usdt_40.svg": 601,
	"./ic_wallet_24.svg": 315,
	"./ic_wavax_24.svg": 602,
	"./ic_wavax_40.svg": 603,
	"./ic_wbtc_24.svg": 604,
	"./ic_wbtc_40.svg": 605,
	"./ic_weth_24.svg": 606,
	"./ic_weth_40.svg": 607,
	"./lg_arbitrum.svg": 608,
	"./logo_GMX.svg": 169,
	"./logo_GMX_small.svg": 241,
	"./long.svg": 316,
	"./metamask-text.svg": 609,
	"./metamask.png": 317,
	"./page-not-found.svg": 610,
	"./position-share-bg.png": 318,
	"./short.svg": 319,
	"./swap.svg": 320,
	"./trading.jpg": 611,
	"./wallet-connect-text.svg": 612,
	"./walletconnect-circle-blue.svg": 321,
	"./wave-01.png": 613,
	"./wave-02.png": 614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;